<template>
  <div>
    <member-detail-link :detailLayout="detailLayout"></member-detail-link>
  </div>
</template>

<script>
import MemberDetailLink from "@/components/member/MemberDetailLink";
import memberUtil from "@/components/member/memberUtil";

export default {
  name: "MemberDetailComponent",
  mixins: [memberUtil],
  components: {
    MemberDetailLink
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    memberType: '',
  },
  data() {
    return{
      detailLayout: '',
    }
  },
  beforeRouterEnter() {},
  created() {
    this.initConfig();
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    initConfig(){
      let memberConfig = this.returnMemberConfig(this.memberType);
      this.detailLayout = memberConfig.detailLayout;
      console.log(this.detailLayout);
    }
  },
  watch: {

  },
}
</script>

<style scoped>

</style>